import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-610">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-611">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-612">
          <div className="md:col-span-2" data-id="element-613">
            <Link to="/" className="inline-block mb-4" data-id="element-614">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-615" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-616">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-617">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-618">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-619">
              <li data-id="element-620">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-621">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-622">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-623">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-624">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-625">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-626">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-627">
              <li className="flex justify-between" data-id="element-628">
                <span data-id="element-629">{t('footer.monFri')}</span>
                <span data-id="element-630">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-631">
                <span data-id="element-632">{t('footer.saturday')}</span>
                <span data-id="element-633">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-634">
                <span data-id="element-635">{t('footer.sunday')}</span>
                <span data-id="element-636">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-637">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-638">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-639">
              <li data-id="element-640">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-641">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-642">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-643">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-644">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-645">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-646">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-647">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-648">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-649">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-650">
          <p data-id="element-651">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-652">
            <a href="#" className="hover:text-white transition-colors" data-id="element-653">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-654">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-655" />
    </footer>;
}